import styled from "styled-components";

export const NewRequestContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  @media (min-width: 768px) {
    display: grid;
    grid-template-columns: 14% 50% 36%;
    // height: 100%;
    /* overflow-y: auto; */
  }
`;

export const InputSearch = styled.input`
  width: 100%;
  border-radius: 0.3rem;
  outline: initial !important;
  box-shadow: initial !important;
  font-size: 0.8rem;
  padding: 0.7rem 0.75rem 0.65rem 0.75rem;
  line-height: 1.5;
  border: 1px solid #d7d7d7;
  background: #f5f5f5;
  color: #212121;
`;

export const ListUsers = styled.input`
  width: 100%;
`;

export const NewRequestContainerDetalle = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 0px, 70px, 70px, 0;
  @media (min-width: 768px) {
    display: grid;
    grid-template-columns: 50% 50%;
    height: 100%;
    padding: 0px 20px 0px 20px;
    margin-left: 200px;
    /* overflow-y: auto; */
  }
`;

export const NewRequestForm = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 6px;

  @media (max-width: 768px) {
    padding: 2rem 0;
    text-align: center;
  }
`;

export const NewRequestFormApplicant = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 2rem 4rem 0 0;
  gap: 6px;

  @media (max-width: 768px) {
    padding: 2rem 0;
  }
  padding: 13px;
  border-left-style: solid;
  border-left-color: #cfcfcf;
  border-left-width: 1px;
  border-top-style: solid;
  border-top-color: #cfcfcf;
  border-top-width: 1px;
`;

export const ProductImage = styled.div`
   ;
`;

export const NormalInputsFields = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  @media (min-width: 640px) {
    display: grid;
    grid-template-columns: 28% auto;
    grid-gap: 2%;
  }
`;

export const SubmitButtons = styled.button`
  width: 100%;
  height: 2.3rem;
  display: block;
  margin: 0px auto;
  align-items: center;
  justify-content: center;
  border: 1px solid #3948ff;
  border-radius: 7px;
  background-color: #3948ff;
  color: white;

  &:hover {
    text-decoration: none;
    background-color: white;
    border-color: #3948ff;
    color: black;
  }
  &:focus {
    outline: none;
  }
`;

export const NormalInput = styled.input`
  width: 100%;
  border: 1px solid gray;
  height: 38px;
  padding: 0px 10px;
  color: ${(props) => props.color && props.color};
  border-radius: 7px;

  &:focus {
    border-color: #dce6e6;
    outline: none;
  }

  &:hover {
    border-color: #dce6e6;
  }
`;

export const AdjuntarArchivo = styled.label`
  text-decoration: underline;
  color: #3948ff;
  display: flex;
  flex-direction: row;
  gap: 3px;
  cursor: pointer;
  font-weight: bolder;
`;

export const BordeAdjuntar = styled.div`
  "border": "2px dashed #cfcfcf",
  "width": "40%",
  "borderradius": "5px",
  "padding": "6px"
`;
